/**
 * Calculates showcase price from zestimate & earnings percentage
 * @param {string} standingOfferPrice - String representing the zestimate
 * @param {string} percentIncrease - Optional string representing percentage. default value is 0.02
 * @returns {[number, number, number]} - an array of zestimate, showcase & earnings values
 */
export function calculateOfferValues(standingOfferPrice, percentIncrease) {
  if (standingOfferPrice) {
    var zestimatePrice = parseInt(standingOfferPrice, 10);
    var showcasePrice = zestimatePrice * (parseFloat(percentIncrease, 10) || 0.02) + zestimatePrice;
    var earningsDifference = showcasePrice - zestimatePrice;
    return [zestimatePrice, showcasePrice, earningsDifference];
  }

  return null;
}